import { useAppSelector } from 'src/hooks';
import {
  whiteLabelConfigSelector,
  siteNameSelector,
  brandColorsSelector,
  logoUrlSelector,
  shouldRemoveBrandingSelector,
  isDefaultBrandingSelector,
  dashboardUrlSelector,
} from '../store/selectors';

/**
 * Custom hook to access white label configuration throughout the app
 *
 * @example
 * const { siteName, brandColors, logoUrl, shouldRemoveBranding, isDefaultBranding } = useWhiteLabel();
 *
 * // Use in components:
 * <h1>{siteName}</h1>
 * <img src={logoUrl} alt={siteName} />
 * <button style={{ backgroundColor: brandColors.background }}>Click Me</button>
 * {isDefaultBranding && <p>Ready to create amazing events?</p>}
 */
export const useWhiteLabel = () => {
  const config = useAppSelector(whiteLabelConfigSelector);
  const siteName = useAppSelector(siteNameSelector);
  const dashboardUrl = useAppSelector(dashboardUrlSelector);
  const brandColors = useAppSelector(brandColorsSelector);
  const logoUrl = useAppSelector(logoUrlSelector);
  const shouldRemoveBranding = useAppSelector(shouldRemoveBrandingSelector);
  const isDefaultBranding = useAppSelector(isDefaultBrandingSelector);

  return {
    config,
    siteName,
    brandColors,
    logoUrl,
    shouldRemoveBranding,
    isDefaultBranding,
    dashboardUrl,
    isLoaded: config !== null,
  };
};
